export const checkIfAllFilled = (values: string[]) => {
    let toReturn = true;
    values.forEach(value => {
        if (value === '') toReturn = false;
    });
    return toReturn;
};
